export default __webpack_public_path__ + "static/media/fireFN12.5f3aec6c.svg";